import { atom } from "jotai";

export const stepIndexAtom = atom(null);
export const partnerPopupPayloadAtom = atom(null);
export const stepsAtom = atom([]);
export const runAtom = atom(false);
export const isFirstDisplayAtom = atom(false);
